/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clean_Heroic_Skate_StartleInputs */

const fr_clean_heroic_skate_startle = /** @type {(inputs: Clean_Heroic_Skate_StartleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta charge sur 1RM`)
};

/**

* @param {Clean_Heroic_Skate_StartleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const clean_heroic_skate_startle = /** @type {((inputs?: Clean_Heroic_Skate_StartleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clean_Heroic_Skate_StartleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_clean_heroic_skate_startle(inputs)
});